// src/Header.js
import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header-container">
      <h1 className='header-content'>Join Us for A Green Tomorrow</h1>
      <p className='header-paragraph'>Welcome to our Tree Planting Event! 🌳 Together, let's make a positive impact on the environment and create a greener, healthier future. By signing up, you're taking a meaningful step towards sustainability.</p>
    </header>
  );
};

export default Header;
